import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LOGO_URL } from "@/lib/constants";

export default function Loader() {
  const [show, setShow] = useState(typeof window !== "undefined" && !sessionStorage.getItem("luhai_loaded"));
  const [pct, setPct] = useState(0);
  useEffect(() => {
    if (!show) return;
    let p = 0;
    const t = setInterval(() => {
      p = Math.min(100, p + Math.random() * 24);
      setPct(Math.floor(p));
      if (p >= 100) { clearInterval(t); sessionStorage.setItem("luhai_loaded", "1"); setTimeout(() => setShow(false), 350); }
    }, 130);
    return () => clearInterval(t);
  }, [show]);
  return (
    <AnimatePresence>
      {show && (
        <motion.div exit={{ opacity: 0 }} transition={{ duration: 0.6 }} className="fixed inset-0 z-[200] bg-[#090A0F] grain flex flex-col items-center justify-center" data-testid="loader">
          <motion.img src={LOGO_URL} alt="LUHAI" className="h-10 sm:h-12" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} />
          <div className="mt-8 w-48 h-px bg-white/10 overflow-hidden"><div className="h-full bg-[#02AACF] transition-all duration-150" style={{ width: `${pct}%` }} /></div>
          <p className="mt-3 font-mono2 text-xs text-[#64748B]">{pct}%</p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
